module.exports = __webpack_public_path__ + "static/media/xinghai02.55bfe17b.jpg";